import rules from '@anchor/vue-assets/src/plugins/form-rules';

export default {
  name: [
    rules.required,
  ],
};
